import { useNavigate } from 'react-router-dom';
import {
  Button,
  ICONS,
  PLATFORM_THEME_COLORS,
  Popover,
  Icon,
} from '@thinknet-gmbh/platform-common-ui';

import { ROUTES } from 'src/components/app/app-routes.constants';

import { EMPLOYEE_PAGES } from '../../../../employee.constants';
import { ButtonLabelContainer } from './create-employee-button.styles';

const CreateEmployeeButton = ({ t }: { t: Function }) => {
  const navigate = useNavigate();

  return (
    <Popover
      trigger={'click'}
      placement="bottom"
      elements={[
        {
          key: 'manually ',
          label: t('employee:labels.manually'),
          handler: () => {
            navigate(`${ROUTES.employee}/${EMPLOYEE_PAGES.createEmployee}`);
          },
        },
        {
          key: 'By questioner ',
          label: t('employee:labels.byQuestionnaire'),
          handler: () => {
            navigate(`${ROUTES.employee}/${EMPLOYEE_PAGES.createEmployeeByQuestionnaire}`);
          },
        },
      ]}
    >
      <Button type="primary" icon={ICONS.plus} iconColor={PLATFORM_THEME_COLORS.primary.white}>
        <ButtonLabelContainer>
          {t('employee:buttons.createNewEmployee')}
          <Icon
            icon={ICONS.chevronDown}
            color={PLATFORM_THEME_COLORS.primary.white}
            leftMargin={true}
            size={16}
          />
        </ButtonLabelContainer>
      </Button>
    </Popover>
  );
};

export default CreateEmployeeButton;
